<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-select v-model="product" style="width: 240px" allowClear showSearch
                  :maxTagCount="1" placeholder="请选择产品"
                  optionFilterProp="label"
                  @change="init_data()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!--<a-form-item>-->
      <!--  <a-select v-model="channel" style="width: 200px" allowClear-->
      <!--            mode="multiple" :maxTagCount="1" placeholder="请选择展示渠道"-->
      <!--            @change="init_data">-->
      <!--    <a-select-option v-for="(channelName,channelItem) in channelList"-->
      <!--                     :key="channelItem">-->
      <!--      {{channelName}}-->
      <!--    </a-select-option>-->
      <!--  </a-select>-->
      <!--</a-form-item>-->
      <a-form-item>
        <a-tooltip style="cursor: pointer">
          <template slot="title" >
            <div v-for="item_channel in Object.keys($store.state.RevenueChange)">
              渠道：{{item_channel}} <br>
              处理：{{$store.state.RevenueChange[item_channel]}}
            </div>
          </template>
          规则<a-icon type="info-circle" theme="filled" />
        </a-tooltip>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" html-type="submit" >导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_data()" />
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
             :data-source="tableData"
             :rowKey="item=>item.channel" :loading="tableLoad"
             bordered :pagination="false">
      <!--<template slot="footer"  slot-scope="currentPageData">-->
      <!--  <a-pagination-->
      <!--    v-model="page"-->
      <!--    style="text-align: right"-->
      <!--    show-size-changer-->
      <!--    :total="count"-->
      <!--    :page-size="page_size"-->
      <!--    @change="changePage"-->
      <!--    @showSizeChange="changePage"-->
      <!--  />-->
      <!--</template>-->
    </a-table>
  </div>
</template>

<script>
import {GetCashCheckChannel} from "../../../api/v1/cash_api";

export default {
  name: "Index",
  data(){
    return {
      product:undefined,
      date:['',''],
      tableData:[],
      tableLoad:false
    }
  },
  watch:{},
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '渠道',width:200, dataIndex: 'channel',fixed:'left',align:'center'},
        {title: '激励',align:'center',children:[{title:'展示',align:'center',dataIndex:'rew_impression'},
            {title:'收益',align:'center',dataIndex:'rew_revenue'}]},
        {title: '插屏', align:'center',children:[{title:'展示',align:'center',dataIndex:'int_impression'},
            {title:'收益',align:'center',dataIndex:'int_revenue'}]},
        {title: 'Banner', align:'center',children:[{title:'展示',align:'center',dataIndex:'ban_impression'},
            {title:'收益',align:'center',dataIndex:'ban_revenue'}]},
        {title: '汇总', align:'center',children:[{title:'展示',align:'center',dataIndex:'count_impression'},
            {title:'收益',align:'center',dataIndex:'count_revenue'}]},
      ]
      return _table_columns
    }
  },
  methods:{
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetCashCheckChannel({
        app_id:this.product,
        start:this.date[0],
        end:this.date[1]
      }).then(resp=>{
        this.tableLoad = false
        if (resp.code===200){
          this.date = resp.data.date
          this.tableData = resp.data.list
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Check/Channel.vue